export default __webpack_public_path__ + "static/media/delete_black_24dp.a53e2203.svg";